import axios, { AxiosError } from "axios";
import url from "../server";

/** 닉네임 중복체크 */
const nick_dup_check = async (nickname: string) => {
  const noGapString = nickname.replaceAll(" ", "");

  // 2~6자 특수문자 제외
  const specialCharRegex = /^[^!@#$%^&*()_+=-]*$/;
  const engCharRegex = /^[^a-zA-Z]*$/;
  if (noGapString.length < 2 || noGapString.length > 8) {
    alert("닉네임은 2~8자로 입력해주세요.");
    return "err";
  } else if (
    !specialCharRegex.test(noGapString) ||
    !engCharRegex.test(noGapString)
  ) {
    alert("닉네임은 영문, 특수문자, 공백 사용이 불가합니다.");
    return "err";
  }

  try {
    const res = await axios.get(url.Communication_url.nick_dup_check, {
      params: { nickname: noGapString },
    });
    return res.data === "사용가능";
  } catch (err) {
    if (err instanceof AxiosError && err.response) {
      const errRes = err.response.data;
      alert(errRes.message);
    } else {
      console.error(err);
    }
    return "err";
  }
};
export default nick_dup_check;

/** 전화번호 중복체크 */
export const phone_dup_check = async (phone: string) => {
  const noGapString = phone.replaceAll(" ", "");

  if (!noGapString.includes("-")) {
    alert("'-' 기호를 넣어서 입력해주세요.");
    return "err";
  }

  // try {
  //   const res = await axios.get(url.Communication_url.phone_dup_check, {
  //     params: { value: noGapString },
  //   });
  //   console.log(res.data);
  //   return res.data === "사용가능";
  // } catch (err) {
  //   if (err instanceof AxiosError && err.response) {
  //     const errRes = err.response.data;
  //     alert(errRes.message);
  //   } else {
  //     console.error(err);
  //   }
  //   return "err";
  // }
};
